import {
  BuiAvatar,
  buiAvatarColorize,
  type BuiAvatarProps,
  type TBuiAvatarColorize,
} from "@btnet/blueprint-components/BuiAvatar";

export type IBTAvatarProps = BuiAvatarProps;

export const btAvatarColorize = buiAvatarColorize;
export type TBTAvatarColorize = TBuiAvatarColorize;

export function BTAvatar(props: IBTAvatarProps) {
  return <BuiAvatar {...props} />;
}
